import type { CommandResult, DeviceCapabilities } from '../../shared/wire';

let _authUserId: number | null = null;
export function getAuthUserId(): number | null { return _authUserId; }
export function setAuthUserId(v: number | null){ _authUserId = v; }

// Server truth: token → {claimed_at, visibility} for this user's live claims.
// null until first fetched (or when signed out).
let _myClaims: Map<string, { claimed_at: number; visibility: string | null; group: string[] }> | null = null;
export function getMyClaims(){ return _myClaims; }
export function setMyClaims(v: typeof _myClaims){ _myClaims = v; }

let _consoleTarget: { token: string; canIssue: boolean } | null = null;
export function getConsoleTarget(){ return _consoleTarget; }
export function setConsoleTarget(v: typeof _consoleTarget){ _consoleTarget = v; }

// The open device drawer's command console: cached capabilities + history, plus
// a poll that accelerates to ~5s while any row is pending (bounded by the 5-min
// TTL), else the normal 30s cadence. One timer, torn down on drawer close /
// view change.
export const cmdConsole: { token: string | null; view: { capabilities: DeviceCapabilities | null; commands: CommandResult[] } | null; timer: number | null } = {
  token: null, view: null, timer: null,
};

// authReady: the boot-time initAuth() promise, set by main.ts boot() so that
// other modules (e.g. map/world.ts) can await auth initialisation without
// importing main. null until boot() runs (safe: any consumer that awaits null
// should guard with a null check).
let _authReady: Promise<void> | null = null;
export function getAuthReady(): Promise<void> | null { return _authReady; }
export function setAuthReady(p: Promise<void>): void { _authReady = p; }
